import React from 'react';

export const WaiverTrainingPayDescription = () => (
  <va-card background>
    <h3 className="vads-u-margin--0">
      Waiver for active or inactive duty training pay
    </h3>
    <p>
      By law, inactive duty or annual duty training pay cannot be paid at the
      same time you are receiving VA compensation or pension payments.
    </p>
    <p>
      Inactive duty training pay may include, but is not limited to, drills,
      schooling, conferences, preparation for inspections, additional flight
      training, muster duty, or funeral honors duty.
    </p>
    <p>
      Annual active training duty is typically performed 15 days each year by
      reservists and members of the National Guard. You may decide to keep the
      training pay you received from your military branch.
    </p>
    <p>
      However, to keep your training pay, you must waive your VA benefits for
      the same number of days as the number of days you received pay for
      inactive duty or annual active duty training. Usually, it is to your
      advantage to waive benefits and keep your training pay.
    </p>
    <p>
      If you select the option to waive VA payments to receive training pay, VA
      will adjust your payments by withholding payment equal ONLY to the number
      of TOTAL training days waived and at the monthly rate in effect for the
      fiscal year period for which you received training pay. This action may
      result in an overpayment of VA compensation, which may be subject to
      collection. In addition, an election to waive VA payments will result in
      automatic adjustments of any future training pay.
    </p>
    <p>
      <strong>Note:</strong> VA compensation is non-taxable. However, in most
      instances, training pay is the greater benefit.
    </p>
  </va-card>
);
